export default __webpack_public_path__ + "media/components/Pay/Index/Images/visa-3d4bf67241fcaaca076484525c82d4e6.svg";